<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 9.16667L10 11.6667L16.6667 5" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.6654 9.99998V15C16.6654 15.9205 15.9192 16.6666 14.9987 16.6666H4.9987C4.07822 16.6666 3.33203 15.9205 3.33203 15V4.99998C3.33203 4.07951 4.07822 3.33331 4.9987 3.33331H12.4987" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>